var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper_box"},[_vm._v(" 轮播组件1 11111111111111111111111111111111111111111111111111111111111 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }